import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { GET_CATALOG, DELETE_CATALOG, UPDATE_CATALOG, ADD_NEW_CATALOG, GET_CATALOG_ONE, GET_CATALOG_AVAILABLE_ONE } from "./actionType";

import { getCatalogSuccess, getCatalogFail, deleteCatalogSuccess, deleteCatalogFail, updateCatalogSuccess, updateCatalogFail, addCatalogSuccess, addCatalogFail } from "./action";

//Include Both Helper File with needed methods
import { approveCatalogApi, getCatalogApi, updateCatalogApi, deleteCatalogApi, addNewCatalogApi, getOneCatalogApi, getOneCatalogAvailableApi } from "../../helpers/backend_helper";

function* getCatalog({ payload: catalog }) {
  try {
    const response = yield call(getCatalogApi, catalog);
    yield put(getCatalogSuccess(GET_CATALOG, response.data));
  } catch (error) {
    yield put(getCatalogFail(GET_CATALOG, error));
  }
}

function* getCatalogOne({ payload: id }) {
  try {
    const response = yield call(getOneCatalogApi, id);
    yield put(getCatalogSuccess(GET_CATALOG_ONE, response.data));
  } catch (error) {
    yield put(getCatalogFail(GET_CATALOG_ONE, error));
  }
}

function* getCatalogAvailableOne({ payload: id }) {
  try {
    const response = yield call(getOneCatalogAvailableApi, id);
    yield put(getCatalogSuccess(GET_CATALOG_AVAILABLE_ONE, response.data));
  } catch (error) {
    yield put(getCatalogFail(GET_CATALOG_AVAILABLE_ONE, error));
  }
}

function* onUpdateCatalog({ payload: catalog }) {
  try {
    if (catalog.setApprove) {
      const response = yield call(approveCatalogApi, catalog);
      yield put(updateCatalogSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    } else {
      const response = yield call(updateCatalogApi, catalog);
      yield put(updateCatalogSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateCatalogFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteCatalog({ payload: catalog }) {
  try {
    const response = yield call(deleteCatalogApi, catalog);
    yield put(deleteCatalogSuccess({ catalog, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteCatalogFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewCatalog({ payload: catalog }) {
  try {
    const response = yield call(addNewCatalogApi, catalog);
    yield put(addCatalogSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addCatalogFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

export function* watchGetCatalog() {
  yield takeEvery(GET_CATALOG, getCatalog);
}

export function* watchGetCatalogOne() {
  yield takeEvery(GET_CATALOG_ONE, getCatalogOne);
}

export function* watchGetCatalogAvailableOne() {
  yield takeEvery(GET_CATALOG_AVAILABLE_ONE, getCatalogAvailableOne);
}

export function* watchUpdateCatalog() {
  yield takeEvery(UPDATE_CATALOG, onUpdateCatalog);
}

export function* watchDeleteCatalog() {
  yield takeEvery(DELETE_CATALOG, onDeleteCatalog);
}

export function* watchAddNewCatalog() {
  yield takeEvery(ADD_NEW_CATALOG, onAddNewCatalog);
}

function* catalogSaga() {
  yield all([fork(watchGetCatalog), fork(watchGetCatalogOne), fork(watchGetCatalogAvailableOne), fork(watchDeleteCatalog), fork(watchUpdateCatalog), fork(watchAddNewCatalog)]);
}

export default catalogSaga;
